module.exports = "/fonts/vendor/bootstrap-icons/bootstrap-icons.woff?c15abee23f0098f0490fe64aafd9d8e5";